import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "../slices/adjustmentOrderSlice";
import adjustmentOrderApis from "src/api/adjustmentOrder";
import { constants } from "src/constants/common";
import { common } from "src/types";

function* GetAdjustmentOrderListSaga({
  payload,
}: ReturnType<typeof actions.getAdjustmentOrderListRequest>) {
  try {
    const response: common.ResponseGenerator = yield call(
      adjustmentOrderApis.list,
      payload
    );
    yield put(actions.getAdjustmentOrderListSuccess(response));
  } catch (error) {
    yield put(
      actions.getAdjustmentOrderListError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

function* CreateAdjustmentOrderSaga({
  payload,
}: ReturnType<typeof actions.createAdjustmentOrderRequest>) {
  try {
    const response: common.ResponseGenerator = yield call(
      adjustmentOrderApis.create,
      payload
    );
    yield put(actions.createAdjustmentOrderSuccess(response));
  } catch (error) {
    yield put(
      actions.createAdjustmentOrderError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

export default function* adjustmentOrderSaga() {
  yield all([
    takeEvery(
      actions.getAdjustmentOrderListRequest,
      GetAdjustmentOrderListSaga
    ),
    takeEvery(actions.createAdjustmentOrderRequest, CreateAdjustmentOrderSaga),
  ]);
}
